import { useEffect } from 'react';

import { useTracker } from '@coursera/event-pulse/react';

import { useAuthModalTrackerContext } from 'bundles/authentication-common/contexts/AuthenticationTracking';

const AuthenticationContentTracker = () => {
  const track = useTracker();
  const authModalEventingContext = useAuthModalTrackerContext();

  useEffect(() => {
    if (authModalEventingContext) {
      const { modalName, formName } = authModalEventingContext;
      if (modalName) {
        track('view_modal', { modal: { name: modalName }, ...(formName ? { form: { name: formName } } : {}) });
      }
    }
  }, [authModalEventingContext, track]);

  return null;
};

export default AuthenticationContentTracker;
